import { request } from '@koi-design/vix-tools';
import { packApi } from '@/libs/tools';
import gConf from 'gConf';

const { augeUrl, augeGateway } = gConf;

export function getLoginCodeApi(data) {
  return request({
    url: `${augeUrl}${augeGateway}/auth/getLoginCode`,
    method: 'get',
    data
  });
}

export function updateCompanyPasswordApi(data) {
  return packApi({
    url: `${augeUrl}${augeGateway}/webUser/updatePassword`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  });
}

export function getAllUsersApi(data) {
  return request({
    url: `${augeUrl}${augeGateway}/webUser/getAllUsers`,
    method: 'post',
    data
  });
}

export function getResourceRootIdOfSystemApi(data) {
  return request({
    url: `${augeUrl}${augeGateway}/webRole/getResourceRootIdOfSystem`,
    method: 'post',
    data
  });
}

export function getAllRolesApi(data) {
  return request({
    url: `${augeUrl}${augeGateway}/webRole/getAllRoles`,
    method: 'post',
    data
  });
}

export function loginOutApi() {
  return request({
    url: `${augeUrl}${augeGateway}/auth/loginOut`,
    method: 'post'
  });
}
